import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptGroups } from "../adapters/adaptGroup";

const fetchAdminGroups = async () => {
	const response = await cmsClient.get<IGroup[]>(
		"/homepage/admin/socialprofilegroup/"
	);

	return response.data;
};

const useAdminGroups = () => {
	const query = useQuery(["admin-groups"], fetchAdminGroups, {
		select: adaptGroups
	});

	return query;
};

export default useAdminGroups;
